var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header_auth"},[_c('HeaderAuthMain'),_vm._v(" "),_c('HeaderMobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }